/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsDeleteApiKey } from "../../funcs/budgetsDeleteApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteApiKeyBudgetRequest$inboundSchema,
};

export const tool$budgetsDeleteApiKey: ToolDefinition<typeof args> = {
  name: "budgets-delete-api-key",
  description: `Delete an apikey budget

Removes the apikey's budget for the given owner; enforcement and alerts stop. Callable by cluster admins, or org admins for API keys in their own organization.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsDeleteApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
